import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getServicioStyle } from "../../../utils/servicioColores";

// Calendario de LIMPIEZAS: pisos de ruta 3 (solo piden productos de limpieza) y
// qué día se les ha COMPRADO (fecha de compra). Arriba, cuántos pisos tuvieron
// compra cada día del rango; abajo, todos los pisos × días con un punto el día
// de cada compra. Al pulsar un punto se ven los productos con su foto.

// Estado de la compra (se ve en la lista de productos al pulsar un punto)
const ESTADO = {
  comprado:       { label: "Comprada (aún no ha salido a repartir)", corto: "Comprada",     color: "#3b82f6" },
  "en reparto":   { label: "En reparto",                              corto: "En reparto",   color: "#8b5cf6" },
  "en la puerta": { label: "Dejada en la puerta",                     corto: "En la puerta", color: "#0d9488" },
  entregado:      { label: "Entregada",                               corto: "Entregada",    color: "#16a34a" },
  pedido:         { label: "Pedido (sin comprar)",                    corto: "Pedido",       color: "#f59e0b" },
};
// Color del círculo según lo gastado ese día en el piso: cuanto más cerca de 0 €, más claro; a partir de TOPE_EUROS, el más oscuro.
const TOPE_EUROS = 50;
const PUNTO_CLARO = [199, 210, 254];
const PUNTO_OSCURO = [49, 46, 129];
const totalCompras$ = (lista) => lista.reduce((a, c) => a + (Number(c.precio_total) || 0), 0);
const colorPunto = (euros) => {
  const t = Math.min(Math.max(euros, 0), TOPE_EUROS) / TOPE_EUROS;
  const rgb = PUNTO_CLARO.map((c, i) => Math.round(c + (PUNTO_OSCURO[i] - c) * t));
  return { fondo: `rgb(${rgb.join(",")})`, texto: t > 0.5 ? "#fff" : "#1e1b4b" };
};
const DIAS_SEMANA = ["L", "M", "X", "J", "V", "S", "D"];
const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
const MESES_CORTOS = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const MAX_DIAS = 186;
const MAX_DIAS_TODO = 3660; // tope de seguridad de "Todo el tiempo" (~10 años)

const p2 = (n) => String(n).padStart(2, "0");
const iso = (d) => `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
const deIso = (s) => new Date(s + "T00:00:00");
const sumarDias = (s, n) => { const d = deIso(s); d.setDate(d.getDate() + n); return iso(d); };
const diasEntre = (a, b) => Math.round((deIso(b) - deIso(a)) / 86400000);
const fmt = (s) => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}` : "");
const fmtLargo = (s) => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : "");
const dowLunes = (s) => (deIso(s).getDay() + 6) % 7; // 0 = lunes
const esFinde = (s) => dowLunes(s) >= 5;

const mesCompleto = (y, m) => ({ desde: iso(new Date(y, m, 1)), hasta: iso(new Date(y, m + 1, 0)) });
const mesActual = () => { const h = new Date(); return { desde: iso(new Date(h.getFullYear(), h.getMonth(), 1)), hasta: iso(new Date(h.getFullYear(), h.getMonth() + 1, 0)) }; };
const PRESETS = [
  { t: "Este mes", f: mesActual },
  { t: "Mes anterior", f: () => { const h = new Date(); return { desde: iso(new Date(h.getFullYear(), h.getMonth() - 1, 1)), hasta: iso(new Date(h.getFullYear(), h.getMonth(), 0)) }; } },
  { t: "Últimos 30 días", f: () => { const h = iso(new Date()); return { desde: sumarDias(h, -29), hasta: h }; } },
  { t: "Últimos 90 días", f: () => { const h = iso(new Date()); return { desde: sumarDias(h, -89), hasta: h }; } },
];

const Tip = ({ tip }) => tip ? (
  <div style={{
    position: "fixed", left: Math.min(tip.x + 14, window.innerWidth - 290), top: Math.min(tip.y + 14, window.innerHeight - 160), zIndex: 3000,
    background: "#0f172a", color: "#fff", borderRadius: 10, padding: "9px 12px", fontSize: 12.5, lineHeight: 1.45,
    pointerEvents: "none", boxShadow: "0 8px 24px rgba(15,23,42,0.3)", maxWidth: 280,
  }}>
    {tip.lines.map((l, i) => <div key={i} style={i === 0 ? { fontWeight: 800, marginBottom: 3 } : undefined}>{l}</div>)}
    <div style={{ marginTop: 4, opacity: 0.6, fontSize: 11.5 }}>Pulsa para ver los productos</div>
  </div>
) : null;

// Lista de productos de las compras de un piso en un día (con foto)
const ModalProductos = ({ piso, dia, compras, onCerrar }) => {
  const [detalle, setDetalle] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let vivo = true;
    Promise.all(compras.map((c) => axios.get(`/api/calendario-limpiezas/compra/${c.id}`).then((r) => r.data)))
      .then((d) => { if (vivo) setDetalle(d); })
      .catch(() => { if (vivo) setError("No se pudieron cargar los productos."); });
    const esc = (e) => { if (e.key === "Escape") onCerrar(); };
    document.addEventListener("keydown", esc);
    return () => { vivo = false; document.removeEventListener("keydown", esc); };
  }, [compras, onCerrar]);
  return (
    <div onClick={onCerrar} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", zIndex: 2500, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, width: "min(620px, 100%)", maxHeight: "88vh", overflowY: "auto", padding: "16px 18px", boxShadow: "0 20px 50px rgba(0,0,0,0.3)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 18, fontWeight: 900, color: "#1e3a5f" }}>🧽 {piso.abreviatura}</div>
            <div style={{ fontSize: 13, color: "#64748b" }}>Comprado el {fmtLargo(dia)}{piso.user_supervisora ? ` · ${piso.user_supervisora}` : ""}</div>
          </div>
          <button onClick={onCerrar} style={{ border: "none", background: "#f1f5f9", borderRadius: 8, padding: "6px 10px", cursor: "pointer", fontWeight: 800 }}>✕</button>
        </div>
        {error && <div style={{ color: "#b91c1c" }}>{error}</div>}
        {!detalle && !error && <div style={{ color: "#94a3b8", padding: 20, textAlign: "center" }}>Cargando productos…</div>}
        {detalle && detalle.map((c) => {
          const e = ESTADO[c.estado] || { corto: c.estado, color: "#64748b" };
          return (
            <div key={c.id} style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", fontSize: 13, marginBottom: 8 }}>
                <span style={{ background: e.color, color: "#fff", borderRadius: 999, padding: "2px 10px", fontWeight: 800 }}>{e.corto}</span>
                <span style={{ color: "#475569" }}>{c.productos.length} producto{c.productos.length !== 1 ? "s" : ""}</span>
                {c.precio_total != null && <strong>{Number(c.precio_total).toFixed(2)} €</strong>}
                {c.user_comprador && <span style={{ color: "#94a3b8" }}>· comprador {c.user_comprador}</span>}
                <span style={{ color: "#cbd5e1" }}>#{c.id}</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {c.productos.map((p, i) => (
                  <div key={`${p.id}-${i}`} style={{ display: "flex", alignItems: "center", gap: 12, border: "1px solid #eef2f7", borderRadius: 12, padding: "6px 10px" }}>
                    {p.imagen
                      ? <img src={p.imagen} alt={p.nombre} loading="lazy" style={{ width: 54, height: 54, objectFit: "contain", borderRadius: 8, background: "#f8fafc", flexShrink: 0 }} />
                      : <div style={{ width: 54, height: 54, borderRadius: 8, background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>🧴</div>}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, color: "#1e293b", fontSize: 14 }}>{p.nombre}</div>
                      {p.subcategoria && <div style={{ fontSize: 12, color: "#94a3b8" }}>{p.subcategoria}</div>}
                    </div>
                    <div style={{ textAlign: "right", whiteSpace: "nowrap", fontSize: 13 }}>
                      <div style={{ fontWeight: 800 }}>× {p.cantidad ?? 1}</div>
                      {p.precio != null && <div style={{ color: "#64748b" }}>{Number(p.precio).toFixed(2)} €</div>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const selStyle = {
  padding: "9px 12px", borderRadius: 12, border: "2px solid #c7d2fe", fontSize: 13.5, fontWeight: 700, color: "#3730a3",
  background: "linear-gradient(135deg,#fff,#eef2ff)", cursor: "pointer", outline: "none",
};

const CalendarioLimpiezas = () => {
  const navigate = useNavigate();
  const [rango, setRango] = useState(mesActual);
  const [todo, setTodo] = useState(false);                   // "Todo el tiempo": el servidor decide desde qué primera compra
  const [rangoTodo, setRangoTodo] = useState(null);          // {desde, hasta} que devuelve el servidor en ese modo
  const [personalizado, setPersonalizado] = useState(false); // muestra las fechas "Del… al…"
  const [borrador, setBorrador] = useState(mesActual);       // fechas que se están eligiendo (se aplican con "Aplicar")
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [sup, setSup] = useState("todas");
  const [servicio, setServicio] = useState("todos");
  const [busca, setBusca] = useState("");
  const [nCompras, setNCompras] = useState(null); // filtro: pisos con exactamente N compras
  const [diaSel, setDiaSel] = useState(null);
  const [orden, setOrden] = useState("piso");
  const [tip, setTip] = useState(null);
  const [modal, setModal] = useState(null); // {piso, dia, compras}
  const cerrarModal = useCallback(() => setModal(null), []);

  const { desde, hasta } = todo && rangoTodo ? rangoTodo : rango;
  const hoy = iso(new Date());
  const dias = useMemo(() => {
    const out = [];
    for (let d = desde; d <= hasta && (todo || out.length <= MAX_DIAS) && out.length <= MAX_DIAS_TODO; d = sumarDias(d, 1)) out.push(d);
    return out;
  }, [desde, hasta, todo]);

  useEffect(() => {
    if (!todo && (!rango.desde || !rango.hasta || rango.desde > rango.hasta)) return;
    setCargando(true); setError(""); setDiaSel(null); setNCompras(null);
    axios.get("/api/calendario-limpiezas/", { params: todo ? { todo: 1 } : { desde: rango.desde, hasta: rango.hasta } })
      .then((r) => { setDatos(r.data); if (todo) setRangoTodo({ desde: r.data.desde, hasta: r.data.hasta }); })
      .catch((e) => setError(e.response?.data?.error || "No se pudo cargar el calendario."))
      .finally(() => setCargando(false));
  }, [todo, rango]);

  // ◀ ▶: pasa al mes completo anterior / siguiente (tomando como referencia el mes de "Del")
  const refMes = deIso(desde);
  const esMesCompleto = !todo && (() => { const m = mesCompleto(refMes.getFullYear(), refMes.getMonth()); return m.desde === desde && m.hasta === hasta; })();
  const cambiarMes = (delta) => { setPersonalizado(false); setTodo(false); setRango(mesCompleto(refMes.getFullYear(), refMes.getMonth() + delta)); };
  const elegirPreset = (v) => { setPersonalizado(false); setTodo(false); setRango(v); };
  const elegirTodo = () => { setPersonalizado(false); setTodo(true); };
  const abrirPersonalizado = () => { setBorrador({ desde, hasta: diasEntre(desde, hasta) > MAX_DIAS ? sumarDias(desde, MAX_DIAS) : hasta }); setPersonalizado(true); };
  const aplicarPersonalizado = () => { setTodo(false); setRango(borrador); };
  const borradorValido = borrador.desde && borrador.hasta && borrador.desde <= borrador.hasta;

  const setFecha = (k, v) => {
    if (!v) return;
    setBorrador((r) => {
      const n = { ...r, [k]: v };
      if (n.desde > n.hasta) { if (k === "desde") n.hasta = v; else n.desde = v; }
      if (diasEntre(n.desde, n.hasta) > MAX_DIAS) { if (k === "desde") n.hasta = sumarDias(v, MAX_DIAS); else n.desde = sumarDias(v, -MAX_DIAS); }
      return n;
    });
  };

  // compras por piso y día (fecha de compra)
  const porPisoDia = useMemo(() => {
    const m = new Map();
    (datos?.compras || []).forEach((c) => {
      if (!c.dia_compra) return;
      const k = `${c.id_piso}|${c.dia_compra.slice(0, 10)}`;
      if (!m.has(k)) m.set(k, []);
      m.get(k).push(c);
    });
    return m;
  }, [datos]);
  const comprasPorPiso = useMemo(() => {
    const m = new Map();
    (datos?.compras || []).forEach((c) => { if (c.dia_compra) m.set(c.id_piso, (m.get(c.id_piso) || 0) + 1); });
    return m;
  }, [datos]);

  const pisos = useMemo(() => datos?.pisos || [], [datos]);
  const supervisoras = useMemo(() => [...new Set(pisos.map((p) => p.user_supervisora).filter(Boolean))].sort(), [pisos]);
  const servicios = useMemo(() => [...new Set(pisos.map((p) => p.servicio).filter(Boolean))].sort(), [pisos]);
  const base = useMemo(() => pisos.filter((p) => (sup === "todas" || p.user_supervisora === sup) && (servicio === "todos" || p.servicio === servicio)), [pisos, sup, servicio]);

  // reparto: cuántos pisos han tenido N compras en el rango (del máximo a 0)
  const reparto = useMemo(() => {
    const m = new Map();
    base.forEach((p) => { const n = comprasPorPiso.get(p.id) || 0; m.set(n, (m.get(n) || 0) + 1); });
    const max = Math.max(0, ...m.keys());
    return Array.from({ length: max + 1 }, (_, i) => max - i).map((n) => ({ n, pisos: m.get(n) || 0 }));
  }, [base, comprasPorPiso]);
  const conCompra = base.filter((p) => comprasPorPiso.get(p.id)).length;
  const totalCompras = base.reduce((a, p) => a + (comprasPorPiso.get(p.id) || 0), 0);

  const pisosPorDia = useMemo(() => {
    const m = new Map();
    base.forEach((p) => dias.forEach((d) => { if (porPisoDia.has(`${p.id}|${d}`)) m.set(d, (m.get(d) || 0) + 1); }));
    return m;
  }, [base, dias, porPisoDia]);
  const maxDia = Math.max(1, ...pisosPorDia.values());

  const filas = useMemo(() => {
    const q = busca.trim().toLowerCase();
    return base.filter((p) => (!q || `${p.abreviatura} ${p.user_supervisora || ""} ${p.nombre_asistenta || ""}`.toLowerCase().includes(q))
      && (nCompras == null || (comprasPorPiso.get(p.id) || 0) === nCompras)
      && (diaSel == null || porPisoDia.has(`${p.id}|${diaSel}`)))
      .sort((a, b) => (orden === "ultima"
        ? String(a.ultima_compra || "").localeCompare(String(b.ultima_compra || "")) || a.abreviatura.localeCompare(b.abreviatura)
        : orden === "n" ? (comprasPorPiso.get(a.id) || 0) - (comprasPorPiso.get(b.id) || 0) || a.abreviatura.localeCompare(b.abreviatura)
          : String(a.abreviatura).localeCompare(String(b.abreviatura), "es", { numeric: true })));
  }, [base, busca, nCompras, diaSel, orden, comprasPorPiso, porPisoDia]);

  // semanas (lunes a domingo) que cubren el rango, para el calendario de arriba
  const semanas = useMemo(() => {
    if (!dias.length) return [];
    const out = [];
    let lun = sumarDias(dias[0], -dowLunes(dias[0]));
    const semanaDesde = (l) => Array.from({ length: 7 }, (_, i) => sumarDias(l, i));
    while (lun <= dias[dias.length - 1]) { out.push(semanaDesde(lun)); lun = sumarDias(lun, 7); }
    return out;
  }, [dias]);

  const tipCompra = (e, p, d, lista) => setTip({
    x: e.clientX, y: e.clientY, lines: [
      `${p.abreviatura} · ${fmtLargo(d)}`,
      ...lista.map((c) => `${ESTADO[c.estado]?.corto || c.estado} · ${c.n_productos} producto${c.n_productos !== 1 ? "s" : ""}${c.precio_total != null ? ` · ${Number(c.precio_total).toFixed(2)} €` : ""}`),
    ],
  });

  return (
    <div style={{ minHeight: "100vh", background: "#f1f5f9", fontFamily: "Segoe UI, sans-serif" }}>
      <div style={{ background: "#1e3a5f", color: "#fff", padding: "14px 18px", display: "flex", alignItems: "center", gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: 8, color: "#fff", fontWeight: 700, cursor: "pointer", padding: "8px 14px" }}>← Volver</button>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, opacity: 0.7 }}>Compras · ruta 3 · por fecha de compra</div>
          <strong style={{ fontSize: 20 }}>🧽 Calendario de limpiezas</strong>
        </div>
      </div>

      <div style={{ padding: "14px 16px", maxWidth: 1600, margin: "0 auto" }}>
        {/* Rango de fechas + filtros */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center", marginBottom: 12 }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#fff", borderRadius: 12, border: "2px solid #c7d2fe", padding: "4px 6px" }}>
            <button onClick={() => cambiarMes(-1)} title="Mes anterior" style={s.flecha}>◀</button>
            <strong style={{ minWidth: 140, textAlign: "center", color: esMesCompleto || todo ? "#1e293b" : "#94a3b8", textTransform: "capitalize", fontSize: 14 }}>
              {todo ? "Todo el tiempo" : esMesCompleto ? `${MESES[refMes.getMonth()]} ${refMes.getFullYear()}` : `${fmt(desde)} – ${fmt(hasta)}`}
            </strong>
            <button onClick={() => cambiarMes(1)} title="Mes siguiente" style={s.flecha}>▶</button>
          </div>
          <div style={{ display: "inline-flex", flexWrap: "wrap", gap: 4 }}>
            {PRESETS.map((pr) => {
              const v = pr.f(); const act = !personalizado && !todo && v.desde === desde && v.hasta === hasta;
              return <button key={pr.t} onClick={() => elegirPreset(v)} style={s.preset(act)}>{pr.t}</button>;
            })}
            <button onClick={elegirTodo} title="Desde la primera compra hasta hoy" style={s.preset(todo && !personalizado)}>♾️ Todo el tiempo</button>
            <button onClick={personalizado ? () => setPersonalizado(false) : abrirPersonalizado} style={s.preset(personalizado)}>🗓️ Personalizado</button>
          </div>
          {personalizado && (
            <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#fff", borderRadius: 12, border: "2px solid #4338ca", padding: "4px 6px 4px 10px" }}>
              <span style={{ fontSize: 13, fontWeight: 800, color: "#3730a3" }}>Del</span>
              <input type="date" value={borrador.desde} onChange={(e) => setFecha("desde", e.target.value)} style={{ border: "none", fontSize: 13.5, fontWeight: 700, outline: "none" }} />
              <span style={{ fontSize: 13, fontWeight: 800, color: "#3730a3" }}>al</span>
              <input type="date" value={borrador.hasta} onChange={(e) => setFecha("hasta", e.target.value)} style={{ border: "none", fontSize: 13.5, fontWeight: 700, outline: "none" }} />
              <button onClick={aplicarPersonalizado} disabled={!borradorValido || (borrador.desde === desde && borrador.hasta === hasta)} style={{
                border: "none", borderRadius: 8, padding: "7px 14px", fontWeight: 800, fontSize: 13, cursor: "pointer", background: "#4338ca", color: "#fff",
                opacity: !borradorValido || (borrador.desde === desde && borrador.hasta === hasta) ? 0.45 : 1,
              }}>Aplicar</button>
            </div>
          )}
          {supervisoras.length > 1 && (
            <select value={sup} onChange={(e) => setSup(e.target.value)} style={selStyle}>
              <option value="todas">👩‍💼 Todas las supervisoras</option>
              {supervisoras.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          )}
          {servicios.length > 1 && (
            <select value={servicio} onChange={(e) => setServicio(e.target.value)} style={selStyle}>
              <option value="todos">🧾 Todos los servicios</option>
              {servicios.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          )}
          <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="🔍 Piso, supervisora, asistenta…"
            style={{ flex: 1, minWidth: 200, padding: "9px 12px", borderRadius: 12, border: "2px solid #c7d2fe", fontSize: 13.5, outline: "none" }} />
        </div>

        {error && <div style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 10, padding: 12, marginBottom: 12 }}>{error}</div>}

        {/* Resumen */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 10 }}>
          {[
            { t: "Pisos ruta 3", v: base.length, c: "#1e3a5f", bg: "#fff" },
            { t: "Con alguna compra", v: conCompra, c: "#15803d", bg: "#dcfce7" },
            { t: "Sin compras", v: base.length - conCompra, c: "#b45309", bg: "#fef3c7" },
            { t: "Compras en el rango", v: totalCompras, c: "#3730a3", bg: "#eef2ff" },
          ].map((k) => (
            <div key={k.t} style={{ background: k.bg, borderRadius: 14, padding: "10px 16px", minWidth: 150, border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: k.c }}>{k.t}</div>
              <div style={{ fontSize: 26, fontWeight: 900, color: "#1e293b" }}>{datos ? k.v : "…"}</div>
            </div>
          ))}
        </div>
        {/* Reparto por nº de compras (del máximo a 0) */}
        {datos && (
          <div style={{ background: "#fff", borderRadius: 14, padding: "10px 14px", border: "1px solid #e2e8f0", marginBottom: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: "#334155", marginBottom: 8 }}>
              Pisos según cuántas compras han tenido del {fmtLargo(desde)} al {fmtLargo(hasta)} <span style={{ fontWeight: 500, color: "#94a3b8" }}>(pulsa para ver solo esos)</span>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {reparto.map(({ n, pisos: np }) => {
                const act = nCompras === n;
                const color = n === 0 ? "#b45309" : "#3730a3";
                return (
                  <button key={n} onClick={() => { setNCompras(act ? null : n); setDiaSel(null); }} disabled={!np} style={{
                    display: "flex", alignItems: "baseline", gap: 8, padding: "8px 14px", borderRadius: 12, cursor: np ? "pointer" : "default",
                    border: `2px solid ${act ? color : "#e2e8f0"}`, background: act ? (n === 0 ? "#fef3c7" : "#eef2ff") : "#fff", opacity: np ? 1 : 0.45,
                  }}>
                    <span style={{ fontSize: 22, fontWeight: 900, color: "#1e293b" }}>{np}</span>
                    <span style={{ fontSize: 12.5, fontWeight: 700, color }}>piso{np !== 1 ? "s" : ""} con {n} compra{n !== 1 ? "s" : ""}</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {/* Calendario del rango */}
        <div style={{ background: "#fff", borderRadius: 14, padding: "12px 14px", border: "1px solid #e2e8f0", marginBottom: 12, overflow: "auto", maxHeight: 460 }}>
          <div style={{ fontSize: 13.5, fontWeight: 800, color: "#334155", marginBottom: 8 }}>
            Pisos con compra cada día <span style={{ fontWeight: 500, color: "#94a3b8" }}>(pulsa un día para ver solo esos pisos)</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(7, minmax(42px, 1fr))", gap: 5, maxWidth: 760 }}>
            {DIAS_SEMANA.map((d) => <div key={d} style={{ textAlign: "center", fontSize: 11.5, fontWeight: 800, color: "#94a3b8" }}>{d}</div>)}
            {semanas.flat().map((d) => {
              const dentro = d >= desde && d <= hasta;
              if (!dentro) return <div key={d} />;
              const n = pisosPorDia.get(d) || 0, t = n / maxDia, sel = diaSel === d;
              const bg = n ? `rgba(67,56,202,${0.12 + t * 0.78})` : "#f8fafc";
              return (
                <button key={d} onClick={() => { setDiaSel((x) => (x === d ? null : d)); setNCompras(null); }}
                  title={`${fmtLargo(d)}: ${n} piso${n !== 1 ? "s" : ""}`}
                  style={{
                    height: 52, borderRadius: 10, cursor: "pointer", background: bg, color: t > 0.45 ? "#fff" : "#1e293b",
                    border: sel ? "3px solid #f59e0b" : d === hoy ? "2px solid #1e3a5f" : "1px solid #e2e8f0",
                    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1,
                  }}>
                  <span style={{ fontSize: 10.5, opacity: 0.85 }}>{d.slice(8, 10) === "01" || d === desde ? `${+d.slice(8, 10)} ${MESES_CORTOS[+d.slice(5, 7) - 1]}` : +d.slice(8, 10)}</span>
                  <span style={{ fontSize: 17, fontWeight: 900 }}>{n || ""}</span>
                </button>
              );
            })}
          </div>
          {diaSel != null && (
            <div style={{ marginTop: 8, fontSize: 13, color: "#92400e" }}>
              Mostrando solo los pisos con compra el <strong>{fmtLargo(diaSel)}</strong>.{" "}
              <span onClick={() => setDiaSel(null)} style={{ color: "#4338ca", cursor: "pointer", fontWeight: 700 }}>Quitar</span>
            </div>
          )}
        </div>

        {/* Leyenda + orden */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 14, alignItems: "center", fontSize: 12.5, color: "#475569", marginBottom: 8 }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
            <span style={{ width: 12, height: 12, borderRadius: "50%", background: colorPunto(TOPE_EUROS / 2).fondo, border: "1px solid rgba(49,46,129,0.45)", boxSizing: "border-box" }} />
            Día con compra (con número = varias compras ese día)
          </span>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            0 €
            <span style={{ width: 90, height: 10, borderRadius: 999, border: "1px solid rgba(49,46,129,0.35)", background: `linear-gradient(90deg, ${colorPunto(0).fondo}, ${colorPunto(TOPE_EUROS).fondo})` }} />
            {TOPE_EUROS} € o más <span style={{ color: "#94a3b8" }}>(color según lo gastado ese día)</span>
          </span>
          <span style={{ marginLeft: "auto" }}>{filas.length} piso{filas.length !== 1 ? "s" : ""} · ordenar por{" "}
            <select value={orden} onChange={(e) => setOrden(e.target.value)} style={{ ...selStyle, padding: "5px 8px", fontSize: 12.5 }}>
              <option value="piso">piso</option>
              <option value="ultima">última compra (más antigua primero)</option>
              <option value="n">nº de compras (menos primero)</option>
            </select>
          </span>
        </div>

        {/* Pisos x días */}
        {cargando && !datos ? <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>Cargando…</div> : (
          <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "auto", maxHeight: "70vh", opacity: cargando ? 0.5 : 1 }}>
            <table style={{ borderCollapse: "separate", borderSpacing: 0, fontSize: 12.5, minWidth: "100%" }}>
              <thead>
                <tr>
                  <th style={{ ...s.thSticky, left: 0, zIndex: 4, minWidth: 190, textAlign: "left" }}>Piso</th>
                  {dias.map((d) => (
                    <th key={d} style={{ ...s.thSticky, minWidth: 26, padding: "4px 0", background: diaSel === d ? "#fde68a" : esFinde(d) ? "#e2e8f0" : "#f1f5f9",
                      color: d === hoy ? "#1e3a5f" : "#64748b", fontWeight: d === hoy ? 900 : 700,
                      borderLeft: d.slice(8, 10) === "01" ? "2px solid #94a3b8" : undefined }}>
                      <div style={{ fontSize: 9, color: "#94a3b8" }}>{d.slice(8, 10) === "01" || d === desde ? MESES_CORTOS[+d.slice(5, 7) - 1] : " "}</div>
                      <div style={{ fontSize: 9.5 }}>{DIAS_SEMANA[dowLunes(d)]}</div>{+d.slice(8, 10)}
                    </th>
                  ))}
                  <th style={{ ...s.thSticky, minWidth: 60 }}>Nº</th>
                  <th style={{ ...s.thSticky, minWidth: 120, textAlign: "left" }}>Última compra</th>
                </tr>
              </thead>
              <tbody>
                {filas.length === 0 ? (
                  <tr><td colSpan={dias.length + 3} style={{ padding: 30, textAlign: "center", color: "#94a3b8" }}>No hay pisos con estos filtros.</td></tr>
                ) : filas.map((p, i) => {
                  const fondo = i % 2 ? "#fafafa" : "#fff";
                  const n = comprasPorPiso.get(p.id) || 0;
                  const hace = p.ultima_compra ? diasEntre(p.ultima_compra.slice(0, 10), hoy) : null;
                  const sc = p.servicio ? getServicioStyle(p.servicio) : null;
                  return (
                    <tr key={p.id}>
                      <td style={{ ...s.td, position: "sticky", left: 0, zIndex: 2, background: fondo, borderRight: "1px solid #e2e8f0" }}>
                        <div style={{ fontWeight: 800, color: "#1e293b", whiteSpace: "nowrap" }}>{p.abreviatura}
                          {sc && <span style={{ marginLeft: 6, fontSize: 10.5, padding: "1px 6px", borderRadius: 6, background: sc.bg, color: sc.color, border: `1px solid ${sc.border}` }}>{p.servicio}</span>}
                        </div>
                        <div style={{ fontSize: 11, color: "#64748b", whiteSpace: "nowrap" }}>{p.user_supervisora || "—"}</div>
                      </td>
                      {dias.map((d) => {
                        const lista = porPisoDia.get(`${p.id}|${d}`);
                        const cp = lista ? colorPunto(totalCompras$(lista)) : null;
                        return (
                          <td key={d} style={{ ...s.td, padding: 0, textAlign: "center", background: diaSel === d ? "#fef3c7" : esFinde(d) ? "#f8fafc" : fondo,
                            borderLeft: d.slice(8, 10) === "01" ? "2px solid #cbd5e1" : "1px solid #f1f5f9", cursor: lista ? "pointer" : "default" }}
                            onMouseMove={lista ? (e) => tipCompra(e, p, d, lista) : undefined} onMouseLeave={lista ? () => setTip(null) : undefined}
                            onClick={lista ? () => { setTip(null); setModal({ piso: p, dia: d, compras: lista }); } : undefined}>
                            {lista && (
                              <span style={{
                                display: "inline-flex", alignItems: "center", justifyContent: "center", width: 18, height: 18, borderRadius: "50%",
                                background: cp.fondo, color: cp.texto, fontSize: 10, fontWeight: 900,
                                boxShadow: "0 0 0 2px #fff", border: "1px solid rgba(49,46,129,0.45)", boxSizing: "border-box",
                              }}>{lista.length > 1 ? lista.length : ""}</span>
                            )}
                          </td>
                        );
                      })}
                      <td style={{ ...s.td, textAlign: "center", fontWeight: 800, color: n ? "#1e293b" : "#cbd5e1" }}>{n || "—"}</td>
                      <td style={{ ...s.td, whiteSpace: "nowrap" }}>
                        {p.ultima_compra ? (
                          <>
                            <strong>{fmt(p.ultima_compra)}/{p.ultima_compra.slice(2, 4)}</strong>
                            <span style={{ marginLeft: 6, fontSize: 11.5, fontWeight: 700, color: hace > 30 ? "#b91c1c" : hace > 14 ? "#b45309" : "#15803d" }}>hace {hace} d</span>
                          </>
                        ) : <span style={{ color: "#b91c1c", fontWeight: 700 }}>nunca</span>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 6 }}>
          Cada punto es una compra en su fecha de compra (número = varias compras ese día; el color, más oscuro cuanto más se gasta, hasta 50 €). Pulsa un punto para ver sus productos. «Última compra» es la fecha de la última compra del piso, aunque sea anterior al rango.
        </div>
      </div>
      <Tip tip={tip} />
      {modal && <ModalProductos {...modal} onCerrar={cerrarModal} />}
    </div>
  );
};

const s = {
  preset: (act) => ({ border: `2px solid ${act ? "#4338ca" : "#c7d2fe"}`, background: act ? "#4338ca" : "#fff", color: act ? "#fff" : "#3730a3", borderRadius: 999, padding: "6px 12px", fontSize: 12.5, fontWeight: 800, cursor: "pointer" }),
  flecha: { border: "none", background: "#eef2ff", borderRadius: 8, padding: "6px 10px", cursor: "pointer", fontWeight: 900, color: "#3730a3" },
  thSticky: { position: "sticky", top: 0, zIndex: 3, background: "#f1f5f9", color: "#64748b", fontSize: 11.5, fontWeight: 700, padding: "8px 8px", borderBottom: "1.5px solid #e2e8f0", textAlign: "center", whiteSpace: "nowrap" },
  td: { padding: "5px 8px", borderBottom: "1px solid #f1f5f9", height: 34, boxSizing: "border-box" },
};

export default CalendarioLimpiezas;
